const _temp0 = require("../images/amazon_icon.svg");

const _temp1 = require("../images/archive_icon.svg");

const _temp2 = require("../images/generic_link_icon.svg");

const _temp3 = require("../images/king-james-bible-kjv.png");

const _temp4 = require("../images/king-james-bible-online.png");

const _temp5 = require("../images/kjv-logo.png");

const _temp6 = require("../images/open-bible.png");

const _temp7 = require("../images/opengraph_banner.png");

const _temp8 = require("../images/typesense.svg");

module.exports = {
  "amazon_icon":   {
    "svg": _temp0
  },
  "archive_icon":   {
    "svg": _temp1
  },
  "generic_link_icon":   {
    "svg": _temp2
  },
  "king-james-bible-kjv":   {
    "png": _temp3
  },
  "king-james-bible-online":   {
    "png": _temp4
  },
  "kjv-logo":   {
    "png": _temp5
  },
  "open-bible":   {
    "png": _temp6
  },
  "opengraph_banner":   {
    "png": _temp7
  },
  "typesense":   {
    "svg": _temp8
  }
}